module.exports = __webpack_public_path__ + "img/88.95e75312.gif";